import { useCallback } from 'react';
import { useGlobalContext } from '../components/GlobalContextProvider';

type TranslationEntry = {
  es: string;
  fr: string;
};

const translation = (es: string, fr: string): TranslationEntry => ({ es, fr });

export const translationEntries: Record<string, TranslationEntry> = {
  Actions: translation('Acciones', 'Actions'),
  'Cash payments': translation('Pagos en efectivo', 'Paiements en espèces'),
  'Pay with cash at Western Union': translation(
    'Pague en efectivo en Western Union',
    'Payez en espèces chez Western Union'
  ),
  'Pay your rent in cash at any Western Union agent location. You’ll need these two details at the counter.':
    translation(
      'Pague su alquiler en efectivo en cualquier agencia de Western Union. Necesitará estos dos datos en el mostrador.',
      'Payez votre loyer en espèces dans n’importe quelle agence Western Union. Vous aurez besoin de ces deux informations au guichet.'
    ),
  'Company name': translation('Nombre de la empresa', 'Nom de l’entreprise'),
  'How to pay': translation('Cómo pagar', 'Comment payer'),
  'Go to any Western Union agent location that accepts bill payments.':
    translation(
      'Vaya a cualquier agencia de Western Union que acepte pagos de facturas.',
      'Rendez-vous dans n’importe quelle agence Western Union qui accepte les paiements de factures.'
    ),
  'Ask to pay a bill, and choose Property Matrix as the company.': translation(
    'Solicite pagar una factura y elija Property Matrix como empresa.',
    'Demandez à payer une facture et choisissez Property Matrix comme entreprise.'
  ),
  'Give them your account number, {accountNumber}.': translation(
    'Proporcione su número de cuenta, {accountNumber}.',
    'Donnez votre numéro de compte, {accountNumber}.'
  ),
  'Pay in cash and keep your receipt until the payment shows in your portal.':
    translation(
      'Pague en efectivo y guarde el recibo hasta que el pago aparezca en su portal.',
      'Payez en espèces et conservez votre reçu jusqu’à ce que le paiement apparaisse dans votre portail.'
    ),
  'Find a location': translation('Buscar una agencia', 'Trouver une agence'),
  Copy: translation('Copiar', 'Copier'),
  Copied: translation('Copiado', 'Copié'),
  'Unable to copy. Select the account number and copy it manually.':
    translation(
      'No se pudo copiar. Seleccione el número de cuenta y cópielo manualmente.',
      'Impossible de copier. Sélectionnez le numéro de compte et copiez-le manuellement.'
    ),
  'This card is unavailable. Please contact your bank or choose another payment method.':
    translation(
      'Esta tarjeta no está disponible. Comuníquese con su banco o elija otro método de pago.',
      'Cette carte est indisponible. Veuillez contacter votre banque ou choisir un autre mode de paiement.'
    ),
  'Your payment could not be processed. Please review your payment status before trying again.':
    translation(
      'No se pudo procesar su pago. Revise el estado de su pago antes de intentarlo de nuevo.',
      'Votre paiement n’a pas pu être traité. Veuillez vérifier son état avant de réessayer.'
    ),
  'This card is temporarily unavailable. You may try again after {time} or use another payment method.':
    translation(
      'Esta tarjeta no está disponible temporalmente. Puede intentarlo de nuevo después de {time} o usar otro método de pago.',
      'Cette carte est temporairement indisponible. Vous pouvez réessayer après {time} ou utiliser un autre mode de paiement.'
    ),
  'This payment method cannot be used for this payment. Please select another payment method.':
    translation(
      'Este método de pago no se puede usar para este pago. Seleccione otro método de pago.',
      'Ce mode de paiement ne peut pas être utilisé pour ce paiement. Veuillez en sélectionner un autre.'
    ),
  'Please check your card number or choose another payment method.':
    translation(
      'Verifique su número de tarjeta o elija otro método de pago.',
      'Veuillez vérifier votre numéro de carte ou choisir un autre mode de paiement.'
    ),
  'Please check your card number.': translation(
    'Verifique su número de tarjeta.',
    'Veuillez vérifier votre numéro de carte.'
  ),
  'Please check your card expiration date.': translation(
    'Verifique la fecha de vencimiento de su tarjeta.',
    'Veuillez vérifier la date d’expiration de votre carte.'
  ),
  'Please check your card security code.': translation(
    'Verifique el código de seguridad de su tarjeta.',
    'Veuillez vérifier le code de sécurité de votre carte.'
  ),
  'Please check your billing address.': translation(
    'Verifique su dirección de facturación.',
    'Veuillez vérifier votre adresse de facturation.'
  ),
  'Please check your bank routing number.': translation(
    'Verifique el número de ruta de su banco.',
    'Veuillez vérifier le numéro d’acheminement de votre banque.'
  ),
  'Please check the state and postal code in your billing address.':
    translation(
      'Verifique el estado y el código postal de su dirección de facturación.',
      'Veuillez vérifier l’État et le code postal de votre adresse de facturation.'
    ),
  'Please check your billing address and phone number.': translation(
    'Verifique su dirección de facturación y número de teléfono.',
    'Veuillez vérifier votre adresse de facturation et votre numéro de téléphone.'
  ),
  'Please check the email address in your payment details.': translation(
    'Verifique el correo electrónico de sus datos de pago.',
    'Veuillez vérifier l’adresse courriel de vos informations de paiement.'
  ),
  'Please check your account details or choose another payment method.':
    translation(
      'Verifique los datos de su cuenta o elija otro método de pago.',
      'Veuillez vérifier les informations de votre compte ou choisir un autre mode de paiement.'
    ),
  'Please check your payment details or choose another payment method.':
    translation(
      'Verifique sus datos de pago o elija otro método de pago.',
      'Veuillez vérifier vos informations de paiement ou choisir un autre mode de paiement.'
    ),
  'This billing country is not supported. Please choose another payment method.':
    translation(
      'Este país de facturación no es compatible. Elija otro método de pago.',
      'Ce pays de facturation n’est pas pris en charge. Veuillez choisir un autre mode de paiement.'
    ),
  'Please contact your bank about this payment or choose another payment method.':
    translation(
      'Comuníquese con su banco sobre este pago o elija otro método de pago.',
      'Veuillez contacter votre banque au sujet de ce paiement ou choisir un autre mode de paiement.'
    ),
  'Your payment was declined. Please contact your bank or choose another payment method.':
    translation(
      'Su pago fue rechazado. Comuníquese con su banco o elija otro método de pago.',
      'Votre paiement a été refusé. Veuillez contacter votre banque ou choisir un autre mode de paiement.'
    ),
  'Your bank has stopped this recurring payment. Please contact your bank or choose another payment method.':
    translation(
      'Su banco detuvo este pago recurrente. Comuníquese con su banco o elija otro método de pago.',
      'Votre banque a arrêté ce paiement récurrent. Veuillez la contacter ou choisir un autre mode de paiement.'
    ),
  'Your bank has stopped recurring payments. Please contact your bank or choose another payment method.':
    translation(
      'Su banco detuvo los pagos recurrentes. Comuníquese con su banco o elija otro método de pago.',
      'Votre banque a arrêté les paiements récurrents. Veuillez la contacter ou choisir un autre mode de paiement.'
    ),
  'This payment exceeds a payment limit. Please contact your property manager or your bank.':
    translation(
      'Este pago supera un límite de pago. Comuníquese con el administrador de su propiedad o con su banco.',
      'Ce paiement dépasse une limite de paiement. Veuillez contacter votre gestionnaire immobilier ou votre banque.'
    ),
  'Your bank is currently unavailable. Please check your payment status before trying again.':
    translation(
      'Su banco no está disponible actualmente. Revise el estado de su pago antes de intentarlo de nuevo.',
      'Votre banque est actuellement indisponible. Veuillez vérifier l’état de votre paiement avant de réessayer.'
    ),
  'This payment account is closed. Please choose another payment method.':
    translation(
      'Esta cuenta de pago está cerrada. Elija otro método de pago.',
      'Ce compte de paiement est fermé. Veuillez choisir un autre mode de paiement.'
    ),
  'There are insufficient funds or available credit for this payment. Please contact your bank or choose another payment method.':
    translation(
      'No hay fondos o crédito disponible suficientes para este pago. Comuníquese con su banco o elija otro método de pago.',
      'Les fonds ou le crédit disponible sont insuffisants pour ce paiement. Veuillez contacter votre banque ou choisir un autre mode de paiement.'
    ),
  'This checking account is unavailable. Please check your bank details or choose another payment method.':
    translation(
      'Esta cuenta corriente no está disponible. Verifique sus datos bancarios o elija otro método de pago.',
      'Ce compte courant est indisponible. Veuillez vérifier vos coordonnées bancaires ou choisir un autre mode de paiement.'
    ),
  'This bank account was not approved for the payment. Please check your bank details or choose another payment method.':
    translation(
      'Esta cuenta bancaria no fue aprobada para el pago. Verifique sus datos bancarios o elija otro método de pago.',
      'Ce compte bancaire n’a pas été approuvé pour le paiement. Veuillez vérifier vos coordonnées bancaires ou choisir un autre mode de paiement.'
    ),
  'This card does not support this payment. Please choose another payment method.':
    translation(
      'Esta tarjeta no admite este pago. Elija otro método de pago.',
      'Cette carte ne permet pas ce paiement. Veuillez choisir un autre mode de paiement.'
    ),
  'This card has expired. Please update your card details or choose another payment method.':
    translation(
      'Esta tarjeta venció. Actualice los datos de su tarjeta o elija otro método de pago.',
      'Cette carte a expiré. Veuillez mettre à jour ses informations ou choisir un autre mode de paiement.'
    ),
  'This payment is not permitted by your bank. Please contact your bank or choose another payment method.':
    translation(
      'Su banco no permite este pago. Comuníquese con su banco o elija otro método de pago.',
      'Votre banque n’autorise pas ce paiement. Veuillez la contacter ou choisir un autre mode de paiement.'
    ),
  'This payment exceeds your withdrawal limit. Please contact your bank or choose another payment method.':
    translation(
      'Este pago supera su límite de retiro. Comuníquese con su banco o elija otro método de pago.',
      'Ce paiement dépasse votre limite de retrait. Veuillez contacter votre banque ou choisir un autre mode de paiement.'
    ),
  'This card is restricted. Please contact your bank or choose another payment method.':
    translation(
      'Esta tarjeta tiene restricciones. Comuníquese con su banco o elija otro método de pago.',
      'Cette carte est soumise à des restrictions. Veuillez contacter votre banque ou choisir un autre mode de paiement.'
    ),
  'Your payment could not be processed. Please contact your property manager for assistance.':
    translation(
      'No se pudo procesar su pago. Comuníquese con el administrador de su propiedad para obtener ayuda.',
      'Votre paiement n’a pas pu être traité. Veuillez contacter votre gestionnaire immobilier pour obtenir de l’aide.'
    ),
  'These invoices cannot be paid together. Please submit separate payments.':
    translation(
      'Estas facturas no se pueden pagar juntas. Envíe pagos por separado.',
      'Ces factures ne peuvent pas être payées ensemble. Veuillez effectuer des paiements séparés.'
    ),
  'Please submit separate payments for each selected invoice.': translation(
    'Envíe un pago por separado para cada factura seleccionada.',
    'Veuillez effectuer un paiement séparé pour chaque facture sélectionnée.'
  ),
  'This payment method is unavailable. Please select another payment method.':
    translation(
      'Este método de pago no está disponible. Seleccione otro método de pago.',
      'Ce mode de paiement est indisponible. Veuillez en sélectionner un autre.'
    ),
  'Online payments are currently unavailable. Please contact your property manager.':
    translation(
      'Los pagos en línea no están disponibles actualmente. Comuníquese con el administrador de su propiedad.',
      'Les paiements en ligne sont actuellement indisponibles. Veuillez contacter votre gestionnaire immobilier.'
    ),
  'Online payments are currently unavailable for the selected invoices. Please contact your property manager.':
    translation(
      'Los pagos en línea no están disponibles actualmente para las facturas seleccionadas. Comuníquese con el administrador de su propiedad.',
      'Les paiements en ligne sont actuellement indisponibles pour les factures sélectionnées. Veuillez contacter votre gestionnaire immobilier.'
    ),
  'Online payments are unavailable for this lease. Please contact your property manager.':
    translation(
      'Los pagos en línea no están disponibles para este contrato de arrendamiento. Comuníquese con el administrador de su propiedad.',
      'Les paiements en ligne sont indisponibles pour ce bail. Veuillez contacter votre gestionnaire immobilier.'
    ),
  'Autopay is unavailable for this lease. Please contact your property manager if you need assistance.':
    translation(
      'El pago automático no está disponible para este contrato. Comuníquese con el administrador de su propiedad si necesita ayuda.',
      'Le paiement automatique est indisponible pour ce bail. Veuillez contacter votre gestionnaire immobilier si vous avez besoin d’aide.'
    ),
  'Autopay is already configured to pay the applicable outstanding balance. Please contact your property manager to review the existing autopay settings.':
    translation(
      'El pago automático ya está configurado para pagar el saldo pendiente correspondiente. Comuníquese con el administrador de su propiedad para revisar la configuración existente.',
      'Le paiement automatique est déjà configuré pour régler le solde impayé applicable. Veuillez contacter votre gestionnaire immobilier pour vérifier les paramètres existants.'
    ),
  'There are no outstanding invoices or a current lease for this payment. Please contact your property manager if you need assistance.':
    translation(
      'No hay facturas pendientes ni un contrato vigente para este pago. Comuníquese con el administrador de su propiedad si necesita ayuda.',
      'Il n’y a pas de factures impayées ni de bail en cours pour ce paiement. Veuillez contacter votre gestionnaire immobilier si vous avez besoin d’aide.'
    ),
  'The selected invoice item is unavailable. Please refresh the page and review your invoices.':
    translation(
      'El concepto de factura seleccionado no está disponible. Actualice la página y revise sus facturas.',
      'L’élément de facture sélectionné est indisponible. Veuillez actualiser la page et vérifier vos factures.'
    ),
  'The selected invoice is unavailable. Please refresh the page and review your invoices.':
    translation(
      'La factura seleccionada no está disponible. Actualice la página y revise sus facturas.',
      'La facture sélectionnée est indisponible. Veuillez actualiser la page et vérifier vos factures.'
    ),
  'This invoice item cannot be paid online. Please contact your property manager.':
    translation(
      'Este concepto de factura no se puede pagar en línea. Comuníquese con el administrador de su propiedad.',
      'Cet élément de facture ne peut pas être payé en ligne. Veuillez contacter votre gestionnaire immobilier.'
    ),
  'Invoice #{number} for {amount} cannot be paid online. Please contact your property manager.':
    translation(
      'La factura n.º {number} por {amount} no se puede pagar en línea. Comuníquese con el administrador de su propiedad.',
      'La facture nº {number} de {amount} ne peut pas être payée en ligne. Veuillez contacter votre gestionnaire immobilier.'
    ),
  'This invoice for {amount} cannot be paid online. Please contact your property manager.':
    translation(
      'Esta factura por {amount} no se puede pagar en línea. Comuníquese con el administrador de su propiedad.',
      'Cette facture de {amount} ne peut pas être payée en ligne. Veuillez contacter votre gestionnaire immobilier.'
    ),
  'Credit card payments are unavailable for this billing location. Please choose another payment method.':
    translation(
      'Los pagos con tarjeta de crédito no están disponibles para esta dirección de facturación. Elija otro método de pago.',
      'Les paiements par carte de crédit sont indisponibles pour cette adresse de facturation. Veuillez choisir un autre mode de paiement.'
    ),
  'Credit card payments are not accepted. Please choose another payment method.':
    translation(
      'No se aceptan pagos con tarjeta de crédito. Elija otro método de pago.',
      'Les paiements par carte de crédit ne sont pas acceptés. Veuillez choisir un autre mode de paiement.'
    ),
  'This card type is not supported. Please choose another payment method.':
    translation(
      'Este tipo de tarjeta no es compatible. Elija otro método de pago.',
      'Ce type de carte n’est pas pris en charge. Veuillez choisir un autre mode de paiement.'
    ),
  'This card type is not accepted. Please use Visa or Mastercard.': translation(
    'No se acepta este tipo de tarjeta. Utilice Visa o Mastercard.',
    'Ce type de carte n’est pas accepté. Veuillez utiliser Visa ou Mastercard.'
  ),
  "We couldn't identify this card. Please check the card number or choose another payment method.":
    translation(
      'No pudimos identificar esta tarjeta. Verifique el número de tarjeta o elija otro método de pago.',
      'Nous n’avons pas pu identifier cette carte. Veuillez vérifier son numéro ou choisir un autre mode de paiement.'
    ),
  'A payment was recently submitted. Please review your payment status before submitting another payment.':
    translation(
      'Se envió un pago recientemente. Revise el estado de su pago antes de enviar otro.',
      'Un paiement a été envoyé récemment. Veuillez vérifier son état avant d’en envoyer un autre.'
    ),
  'A similar payment was recently submitted. Please review your payment status before trying again.':
    translation(
      'Se envió un pago similar recientemente. Revise el estado de su pago antes de intentarlo de nuevo.',
      'Un paiement similaire a été envoyé récemment. Veuillez vérifier son état avant de réessayer.'
    ),
  'The invoice balance has changed, and you have not been charged. Please reload the page to review the updated balance.':
    translation(
      'El saldo de la factura cambió y no se le ha cobrado. Actualice la página para revisar el saldo actualizado.',
      'Le solde de la facture a changé et aucun montant ne vous a été facturé. Veuillez recharger la page pour vérifier le nouveau solde.'
    ),
  'Your payment was successful, but autopay could not be set up. Please contact your property manager for assistance.':
    translation(
      'Su pago se realizó correctamente, pero no se pudo configurar el pago automático. Comuníquese con el administrador de su propiedad para obtener ayuda.',
      'Votre paiement a réussi, mais le paiement automatique n’a pas pu être configuré. Veuillez contacter votre gestionnaire immobilier pour obtenir de l’aide.'
    ),
  "We couldn't update autopay. Please contact your property manager for assistance.":
    translation(
      'No pudimos actualizar el pago automático. Comuníquese con el administrador de su propiedad para obtener ayuda.',
      'Nous n’avons pas pu modifier le paiement automatique. Veuillez contacter votre gestionnaire immobilier pour obtenir de l’aide.'
    ),
  "We couldn't confirm your autopay settings. Please refresh the page or contact your property manager.":
    translation(
      'No pudimos confirmar la configuración del pago automático. Actualice la página o comuníquese con el administrador de su propiedad.',
      'Nous n’avons pas pu confirmer vos paramètres de paiement automatique. Veuillez actualiser la page ou contacter votre gestionnaire immobilier.'
    ),
  'This page is temporarily unavailable. Please try again later.': translation(
    'Esta página no está disponible temporalmente. Inténtelo de nuevo más tarde.',
    'Cette page est temporairement indisponible. Veuillez réessayer plus tard.'
  ),
  "We couldn't connect. Please check your internet connection and try again.":
    translation(
      'No pudimos conectarnos. Verifique su conexión a internet e inténtelo de nuevo.',
      'Nous n’avons pas pu établir la connexion. Veuillez vérifier votre connexion Internet et réessayer.'
    ),
  'The upload was interrupted. Please try again.': translation(
    'La carga se interrumpió. Inténtelo de nuevo.',
    'Le téléversement a été interrompu. Veuillez réessayer.'
  ),
  'Maintenance requests are unavailable for this property. Please contact your property manager.':
    translation(
      'Las solicitudes de mantenimiento no están disponibles para esta propiedad. Comuníquese con el administrador de su propiedad.',
      'Les demandes de maintenance sont indisponibles pour cette propriété. Veuillez contacter votre gestionnaire immobilier.'
    ),
  'This lease is unavailable. Please refresh the page or contact your property manager.':
    translation(
      'Este contrato no está disponible. Actualice la página o comuníquese con el administrador de su propiedad.',
      'Ce bail est indisponible. Veuillez actualiser la page ou contacter votre gestionnaire immobilier.'
    ),
  'This feature is available only for an accessible current or upcoming lease.':
    translation(
      'Esta función solo está disponible para un contrato actual o futuro al que tenga acceso.',
      'Cette fonctionnalité est disponible uniquement pour un bail en cours ou à venir auquel vous avez accès.'
    ),
  'Maintenance suggestions are unavailable. You can still submit a maintenance request.':
    translation(
      'Las sugerencias de mantenimiento no están disponibles. Aún puede enviar una solicitud de mantenimiento.',
      'Les suggestions de maintenance sont indisponibles. Vous pouvez toujours envoyer une demande de maintenance.'
    ),
  'Please select an available request category.': translation(
    'Seleccione una categoría de solicitud disponible.',
    'Veuillez sélectionner une catégorie de demande disponible.'
  ),
  'You do not have access to maintenance suggestions.': translation(
    'No tiene acceso a las sugerencias de mantenimiento.',
    'Vous n’avez pas accès aux suggestions de maintenance.'
  ),
  'Assistant personalization is unavailable.': translation(
    'La personalización del asistente no está disponible.',
    'La personnalisation de l’assistant est indisponible.'
  ),
  'You do not have access to assistant personalization.': translation(
    'No tiene acceso a la personalización del asistente.',
    'Vous n’avez pas accès à la personnalisation de l’assistant.'
  ),
  'You do not have access to the tenant assistant.': translation(
    'No tiene acceso al asistente para inquilinos.',
    'Vous n’avez pas accès à l’assistant des locataires.'
  ),
  'This lease is unavailable in your portal. Please contact your property manager.':
    translation(
      'Este contrato no está disponible en su portal. Comuníquese con el administrador de su propiedad.',
      'Ce bail est indisponible dans votre portail. Veuillez contacter votre gestionnaire immobilier.'
    ),
  'This conversation is unavailable. Please refresh the page.': translation(
    'Esta conversación no está disponible. Actualice la página.',
    'Cette conversation est indisponible. Veuillez actualiser la page.'
  ),
  'This conversation is unavailable to your account.': translation(
    'Esta conversación no está disponible para su cuenta.',
    'Cette conversation est indisponible pour votre compte.'
  ),
  'This conversation is unavailable for the selected lease.': translation(
    'Esta conversación no está disponible para el contrato seleccionado.',
    'Cette conversation est indisponible pour le bail sélectionné.'
  ),
  'This assistant is unavailable. Please refresh the page and try again.':
    translation(
      'Este asistente no está disponible. Actualice la página e inténtelo de nuevo.',
      'Cet assistant est indisponible. Veuillez actualiser la page et réessayer.'
    ),
  'There was an error updating the password. Please contact your property manager for assistance.':
    translation(
      'Ocurrió un error al actualizar la contraseña. Comuníquese con el administrador de su propiedad para obtener ayuda.',
      'Une erreur s’est produite lors de la modification du mot de passe. Veuillez contacter votre gestionnaire immobilier pour obtenir de l’aide.'
    ),
  'There was an error updating the email address. Please contact your property manager for assistance.':
    translation(
      'Ocurrió un error al actualizar el correo electrónico. Comuníquese con el administrador de su propiedad para obtener ayuda.',
      'Une erreur s’est produite lors de la modification de l’adresse courriel. Veuillez contacter votre gestionnaire immobilier pour obtenir de l’aide.'
    ),
  'There was an error updating the language. Please contact your property manager for assistance.':
    translation(
      'Ocurrió un error al actualizar el idioma. Comuníquese con el administrador de su propiedad para obtener ayuda.',
      'Une erreur s’est produite lors de la modification de la langue. Veuillez contacter votre gestionnaire immobilier pour obtenir de l’aide.'
    ),
  'We couldn’t complete your request. Please contact your property manager for assistance. Error code:':
    translation(
      'No pudimos completar su solicitud. Comuníquese con el administrador de su propiedad para obtener ayuda. Código de error:',
      'Nous n’avons pas pu traiter votre demande. Veuillez contacter votre gestionnaire immobilier pour obtenir de l’aide. Code d’erreur :'
    ),
  'We couldn’t confirm whether your payment was completed. Please contact your property manager for assistance before submitting another payment. Error code:':
    translation(
      'No pudimos confirmar si se completó su pago. Comuníquese con el administrador de su propiedad para obtener ayuda antes de enviar otro pago. Código de error:',
      'Nous n’avons pas pu confirmer si votre paiement a été effectué. Veuillez contacter votre gestionnaire immobilier avant d’envoyer un autre paiement. Code d’erreur :'
    ),
  'There is no internet access': translation(
    'No hay conexión a internet',
    'Il n’y a pas de connexion Internet'
  ),
  ' The staff at ': translation(' El personal de ', ' Le personnel de '),
  ' to pay today': translation(' a pagar hoy', " à payer aujourd'hui"),
  ' assistant icon': translation(
    ' icono del asistente',
    " icône de l'assistant"
  ),
  ' can chime in at any time.': translation(
    ' puede participar en cualquier momento.',
    ' peut intervenir à tout moment.'
  ),
  ' is responding': translation(' está respondiendo', ' répond'),
  '0 Bytes': translation('0 bytes', '0 octet'),
  Account: translation('Cuenta', 'Compte'),
  'Account Details': translation('Detalles de la cuenta', 'Détails du compte'),
  'Account details': translation('Detalles de la cuenta', 'Détails du compte'),
  'Account number': translation('Número de cuenta', 'Numéro de compte'),
  'Account number confirmation': translation(
    'Confirmación del número de cuenta',
    'Confirmation du numéro de compte'
  ),
  'ACH Payments are not allowed for this property.': translation(
    'Los pagos ACH no están permitidos para esta propiedad.',
    'Les paiements ACH ne sont pas autorisés pour cette propriété.'
  ),
  'Add a bank account': translation(
    'Agregar una cuenta bancaria',
    'Ajouter un compte bancaire'
  ),
  'Add a card': translation('Agregar una tarjeta', 'Ajouter une carte'),
  'Add ACH withdraw': translation(
    'Agregar un retiro ACH',
    'Ajouter un prélèvement ACH'
  ),
  'Add Attachments': translation(
    'Agregar archivos adjuntos',
    'Ajouter des pièces jointes'
  ),
  'Add new bank account': translation(
    'Agregar una cuenta bancaria nueva',
    'Ajouter un nouveau compte bancaire'
  ),
  'Add new card': translation(
    'Agregar una tarjeta nueva',
    'Ajouter une nouvelle carte'
  ),
  'Adding attachments': translation(
    'Agregando archivos adjuntos',
    'Ajout des pièces jointes'
  ),
  'Added:': translation('Agregado:', 'Ajouté :'),
  Address: translation('Dirección', 'Adresse'),
  'Address Line 1': translation('Línea de dirección 1', "Ligne d'adresse 1"),
  'Address Line 2': translation('Línea de dirección 2', "Ligne d'adresse 2"),
  'AI assistant': translation('Asistente de IA', 'Assistant IA'),
  Amount: translation('Monto', 'Montant'),
  'Amount to pay': translation('Monto a pagar', 'Montant à payer'),
  'Amount to pay ($)': translation('Monto a pagar ($)', 'Montant à payer ($)'),
  'An unknown error occurred while disconnecting the account.': translation(
    'Ocurrió un error desconocido al desconectar la cuenta.',
    "Une erreur inconnue s'est produite lors de la déconnexion du compte."
  ),
  'Answers from your portal information': translation(
    'Respuestas basadas en la información de su portal',
    'Réponses basées sur les informations de votre portail'
  ),
  Applied: translation('Aplicado', 'Imputé'),
  'Are you sure you want to disconnect this account? This action cannot be undone.':
    translation(
      '¿Seguro que desea desconectar esta cuenta? Esta acción no se puede deshacer.',
      'Voulez-vous vraiment déconnecter ce compte ? Cette action est irréversible.'
    ),
  'Ask a question': translation('Hacer una pregunta', 'Poser une question'),
  'Ask a question...': translation(
    'Haga una pregunta...',
    'Posez une question...'
  ),
  Assistant: translation('Asistente', 'Assistant'),
  'Assistant icon': translation('Icono del asistente', "Icône de l'assistant"),
  'Assistant identity mode': translation(
    'Modo de identidad del asistente',
    "Mode d'identité de l'assistant"
  ),
  'Assistant name': translation('Nombre del asistente', "Nom de l'assistant"),
  'Assistant unavailable': translation(
    'Asistente no disponible',
    'Assistant indisponible'
  ),
  Attachments: translation('Archivos adjuntos', 'Pièces jointes'),
  'Auto pay is enabled': translation(
    'El pago automático está activado',
    'Le paiement automatique est activé'
  ),
  'AutoPay - Additional Settings': translation(
    'Pago automático: configuración adicional',
    'Paiement automatique - Paramètres supplémentaires'
  ),
  AutoPay: translation('Pago automático', 'Paiement automatique'),
  'AutoPay Enabled': translation(
    'Pago automático activado',
    'Paiement automatique activé'
  ),
  'AutoPay is disabled': translation(
    'El pago automático está desactivado',
    'Le paiement automatique est désactivé'
  ),
  'Back To Payments': translation('Volver a Pagos', 'Retour aux paiements'),
  'Back to Payments': translation('Volver a Pagos', 'Retour aux paiements'),
  'Back to Documents': translation(
    'Volver a Documentos',
    'Retour aux documents'
  ),
  'Back to Maintenance': translation(
    'Volver a Mantenimiento',
    'Retour à la maintenance'
  ),
  'Back to Support': translation('Volver a Soporte', "Retour à l'assistance"),
  'Bill to': translation('Facturar a', 'Facturer à'),
  Billing: translation('Facturación', 'Facturation'),
  'Billing Address': translation(
    'Dirección de facturación',
    'Adresse de facturation'
  ),
  'Billing history': translation(
    'Historial de facturación',
    'Historique de facturation'
  ),
  'Billing History': translation(
    'Historial de facturación',
    'Historique de facturation'
  ),
  Bytes: translation('bytes', 'octets'),
  Cancel: translation('Cancelar', 'Annuler'),
  Card: translation('Tarjeta', 'Carte'),
  'Card number': translation('Numero de tarjeta', 'Numéro de carte'),
  'Cardholder name': translation(
    'Nombre del titular',
    'Nom du titulaire de la carte'
  ),
  Category: translation('Categoría', 'Catégorie'),
  Change: translation('Cambiar', 'Modifier'),
  'Change email address': translation(
    'Cambiar correo electrónico',
    'Modifier l’adresse courriel'
  ),
  'Change password': translation(
    'Cambiar contraseña',
    'Modifier le mot de passe'
  ),
  'Change Password': translation(
    'Cambiar contraseña',
    'Modifier le mot de passe'
  ),
  'Changing email': translation(
    'Cambiando el correo electrónico',
    "Modification de l'adresse courriel"
  ),
  'Changing password': translation(
    'Cambiando la contraseña',
    'Modification du mot de passe'
  ),
  Chat: translation('Chat', 'Clavardage'),
  Checking: translation('Corriente', 'Compte courant'),
  'Checking details': translation(
    'Datos de la cuenta corriente',
    'Détails du compte courant'
  ),
  City: translation('Ciudad', 'Ville'),
  Close: translation('Cerrar', 'Fermer'),
  'Choose a': translation('Elija un', 'Choisissez un'),
  'Choose User': translation('Elegir usuario', 'Choisir un utilisateur'),
  'Choose the language used throughout the app.': translation(
    'Elija el idioma utilizado en toda la aplicación.',
    "Choisissez la langue utilisée dans toute l'application."
  ),
  'Confirm Password': translation(
    'Confirmar contraseña',
    'Confirmer le mot de passe'
  ),
  'Connected Accounts': translation('Cuentas conectadas', 'Comptes connectés'),
  Contact: translation('Contacto', 'Contact'),
  Country: translation('País', 'Pays'),
  'Credit Card': translation('Tarjeta de crédito', 'Carte de crédit'),
  'Creating maintenance request': translation(
    'Creando la solicitud de mantenimiento',
    'Création de la demande de maintenance'
  ),
  'Creating payment method': translation(
    'Creando el método de pago',
    'Création du mode de paiement'
  ),
  Current: translation('Actuales', 'En cours'),
  'Current Password': translation('Contraseña actual', 'Mot de passe actuel'),
  'Custom fields': translation('Campos personalizados', 'Champs personnalisés'),
  'Customer Logo': translation('Logotipo del cliente', 'Logo du client'),
  'Dark mode': translation('Modo oscuro', 'Mode sombre'),
  'Dark Mode': translation('Modo oscuro', 'Mode sombre'),
  Date: translation('Fecha', 'Date'),
  'date / time': translation('fecha / hora', 'date / heure'),
  'Day of the month': translation('Día del mes', 'Jour du mois'),
  'Debit Card': translation('Tarjeta de débito', 'Carte de débit'),
  Delete: translation('Eliminar', 'Supprimer'),
  'Delete file': translation('Eliminar archivo', 'Supprimer le fichier'),
  'Delete payment method': translation(
    'Eliminar método de pago',
    'Supprimer le mode de paiement'
  ),
  'Deleting document': translation(
    'Eliminando el documento',
    'Suppression du document'
  ),
  'Deleting payment method': translation(
    'Eliminando el método de pago',
    'Suppression du mode de paiement'
  ),
  Details: translation('Detalles', 'Détails'),
  'Disable AutoPay': translation(
    'Desactivar el pago automático',
    'Désactiver le paiement automatique'
  ),
  'Disable Autopay': translation(
    'Desactivar el pago automático',
    'Désactiver le paiement automatique'
  ),
  'Disabling AutoPay': translation(
    'Desactivando el pago automático',
    'Désactivation du paiement automatique'
  ),
  Disconnect: translation('Desconectar', 'Déconnecter'),
  'Disconnecting account': translation(
    'Desconectando la cuenta',
    'Déconnexion du compte'
  ),
  Documents: translation('Documentos', 'Documents'),
  Download: translation('Descargar', 'Télécharger'),
  'Download Receipt': translation('Descargar recibo', 'Télécharger le reçu'),
  'Due Date': translation('Fecha de vencimiento', "Date d'échéance"),
  'Due Date:': translation('Fecha de vencimiento:', "Date d'échéance :"),
  Edit: translation('Editar', 'Modifier'),
  'Edit ACH': translation('Editar ACH', 'Modifier le compte ACH'),
  'Edit billing address': translation(
    'Editar dirección de facturación',
    "Modifier l'adresse de facturation"
  ),
  'Edit card': translation('Editar tarjeta', 'Modifier la carte'),
  'Edit Email Address': translation(
    'Editar correo electrónico',
    "Modifier l'adresse courriel"
  ),
  'Edit payment amount': translation(
    'Editar el monto del pago',
    'Modifier le montant du paiement'
  ),
  Email: translation('Correo electrónico', 'Courriel'),
  'Email Address': translation('Correo electrónico', 'Adresse courriel'),
  'Email address': translation('Correo electrónico', 'Adresse courriel'),
  'Email address updated': translation(
    'Correo electrónico actualizado',
    'Adresse courriel mise à jour'
  ),
  'Password updated': translation(
    'Contraseña actualizada',
    'Mot de passe mis à jour'
  ),
  Theme: translation('Tema', 'Thème'),
  On: translation('Activado', 'Activé'),
  Off: translation('Desactivado', 'Désactivé'),
  'Enable AutoPay': translation(
    'Activar el pago automático',
    'Activer le paiement automatique'
  ),
  'Enabling AutoPay': translation(
    'Activando el pago automático',
    'Activation du paiement automatique'
  ),
  End: translation('Fin', 'Fin'),
  English: translation('Inglés', 'Anglais'),
  Enter: translation('Ingrese', 'Saisissez'),
  Error: translation('Error', 'Erreur'),
  'Exp.': translation('Venc.', 'Exp.'),
  'Expiry date': translation('Vencimiento', "Date d'expiration"),
  'Every payment removes carbon from the air - at no extra cost.': translation(
    'Cada pago elimina carbono del aire, sin costo adicional.',
    "Chaque paiement élimine du carbone de l'air, sans frais supplémentaires."
  ),
  FAQ: translation('Preguntas frecuentes', 'FAQ'),
  'Failed to disconnect the account: ': translation(
    'No se pudo desconectar la cuenta: ',
    'Échec de la déconnexion du compte : '
  ),
  'Failed to send message': translation(
    'No se pudo enviar el mensaje',
    "Échec de l'envoi du message"
  ),
  'Failed to send message.': translation(
    'No se pudo enviar el mensaje.',
    "Échec de l'envoi du message."
  ),
  'File deleted': translation('Archivo eliminado', 'Fichier supprimé'),
  Frequency: translation('Frecuencia', 'Fréquence'),
  Future: translation('Futuros', 'À venir'),
  GB: translation('GB', 'Go'),
  Home: translation('Inicio', 'Accueil'),
  'Hi ': translation('Hola ', 'Bonjour '),
  'I can help with rent, lease details, maintenance updates, documents, and contacting your property manager.':
    translation(
      'Puedo ayudar con el alquiler, los detalles del contrato, las actualizaciones de mantenimiento, los documentos y cómo contactar al administrador de la propiedad.',
      'Je peux vous aider concernant le loyer, les détails du bail, les mises à jour de maintenance, les documents et la communication avec votre gestionnaire immobilier.'
    ),
  'I can help with rent, lease details, maintenance updates, documents, and contacting your property manager. The staff at ':
    translation(
      'Puedo ayudar con el alquiler, los detalles del contrato, las actualizaciones de mantenimiento, los documentos y cómo contactar al administrador de la propiedad. El personal de ',
      'Je peux vous aider concernant le loyer, les détails du bail, les mises à jour de maintenance, les documents et la communication avec votre gestionnaire immobilier. Le personnel de '
    ),
  'I understand': translation('Entendido', "J'ai compris"),
  'If you wish to disable AutoPay you can do so below. You can enable autopay again at any time.':
    translation(
      'Si desea desactivar el pago automático, puede hacerlo a continuación. Puede volver a activarlo en cualquier momento.',
      'Si vous souhaitez désactiver le paiement automatique, vous pouvez le faire ci-dessous. Vous pourrez le réactiver à tout moment.'
    ),
  Invoice: translation('Factura', 'Facture'),
  'Invoice Date': translation('Fecha de la factura', 'Date de la facture'),
  'Invoice Details': translation(
    'Detalles de la factura',
    'Détails de la facture'
  ),
  'Invoice Payment': translation('Pago de factura', 'Paiement de facture'),
  'Invoice Payment Date': translation(
    'Fecha del pago de factura',
    'Date du paiement de facture'
  ),
  'Invoice Payment Details': translation(
    'Detalles del pago de factura',
    'Détails du paiement de facture'
  ),
  Bill: translation('Factura de proveedor', 'Facture fournisseur'),
  'Bill Date': translation(
    'Fecha de la factura de proveedor',
    'Date de la facture fournisseur'
  ),
  'Bill Details': translation(
    'Detalles de la factura de proveedor',
    'Détails de la facture fournisseur'
  ),
  'Bill Payment': translation(
    'Pago de factura de proveedor',
    'Paiement de facture fournisseur'
  ),
  'Bill Payment Date': translation(
    'Fecha del pago de factura de proveedor',
    'Date du paiement de facture fournisseur'
  ),
  'Bill Payment Details': translation(
    'Detalles del pago de factura de proveedor',
    'Détails du paiement de facture fournisseur'
  ),
  Refund: translation('Reembolso', 'Remboursement'),
  'Refund Date': translation('Fecha del reembolso', 'Date du remboursement'),
  'Refund Details': translation(
    'Detalles del reembolso',
    'Détails du remboursement'
  ),
  'Transaction Void': translation(
    'Anulación de transacción',
    'Annulation de transaction'
  ),
  'Transaction Void Date': translation(
    'Fecha de la anulación de transacción',
    "Date de l'annulation de transaction"
  ),
  'Transaction Void Details': translation(
    'Detalles de la anulación de transacción',
    "Détails de l'annulation de transaction"
  ),
  'Credit Note': translation('Nota de crédito', 'Avoir'),
  'Credit Note Date': translation(
    'Fecha de la nota de crédito',
    "Date de l'avoir"
  ),
  'Credit Note Details': translation(
    'Detalles de la nota de crédito',
    "Détails de l'avoir"
  ),
  'Security Deposit Application': translation(
    'Aplicación del depósito de seguridad',
    'Imputation du dépôt de garantie'
  ),
  'Security Deposit Application Date': translation(
    'Fecha de la aplicación del depósito de seguridad',
    "Date de l'imputation du dépôt de garantie"
  ),
  'Security Deposit Application Details': translation(
    'Detalles de la aplicación del depósito de seguridad',
    "Détails de l'imputation du dépôt de garantie"
  ),
  'Journal Entry': translation('Asiento contable', 'Écriture de journal'),
  'Journal Entry Date': translation(
    'Fecha del asiento contable',
    "Date de l'écriture de journal"
  ),
  'Journal Entry Details': translation(
    'Detalles del asiento contable',
    "Détails de l'écriture de journal"
  ),
  'Management Charge': translation(
    'Cargo de administración',
    'Frais de gestion'
  ),
  'Management Charge Date': translation(
    'Fecha del cargo de administración',
    'Date des frais de gestion'
  ),
  'Management Charge Details': translation(
    'Detalles del cargo de administración',
    'Détails des frais de gestion'
  ),
  'Management Charge Payment': translation(
    'Pago del cargo de administración',
    'Paiement des frais de gestion'
  ),
  'Management Charge Payment Date': translation(
    'Fecha del pago del cargo de administración',
    'Date du paiement des frais de gestion'
  ),
  'Management Charge Payment Details': translation(
    'Detalles del pago del cargo de administración',
    'Détails du paiement des frais de gestion'
  ),
  Deposit: translation('Depósito', 'Dépôt'),
  'Deposit Date': translation('Fecha del depósito', 'Date du dépôt'),
  'Deposit Details': translation('Detalles del depósito', 'Détails du dépôt'),
  'Funds Transfer': translation(
    'Transferencia de fondos',
    'Transfert de fonds'
  ),
  'Funds Transfer Date': translation(
    'Fecha de la transferencia de fondos',
    'Date du transfert de fonds'
  ),
  'Funds Transfer Details': translation(
    'Detalles de la transferencia de fondos',
    'Détails du transfert de fonds'
  ),
  Item: translation('Artículo', 'Article'),
  KB: translation('KB', 'ko'),
  Language: translation('Idioma', 'Langue'),
  Lease: translation('Contrato', 'Bail'),
  'Load earlier messages': translation(
    'Cargar mensajes anteriores',
    'Charger les messages précédents'
  ),
  'Load more threads': translation(
    'Cargar más conversaciones',
    'Charger plus de conversations'
  ),
  'Loading earlier messages...': translation(
    'Cargando mensajes anteriores...',
    'Chargement des messages précédents...'
  ),
  'Loading threads...': translation(
    'Cargando conversaciones...',
    'Chargement des conversations...'
  ),
  Maintenance: translation('Mantenimiento', 'Maintenance'),
  'Make a payment': translation('Hacer un pago', 'Effectuer un paiement'),
  'Make a Prepayment': translation(
    'Hacer un prepago',
    'Effectuer un paiement anticipé'
  ),
  MB: translation('MB', 'Mo'),
  Message: translation('Mensaje', 'Message'),
  'Message sent': translation('Mensaje enviado', 'Message envoyé'),
  'Name on account': translation(
    'Nombre en la cuenta',
    'Nom associé au compte'
  ),
  'New ACH': translation('Nuevo ACH', 'Nouveau compte ACH'),
  'New conversation': translation(
    'Nueva conversación',
    'Nouvelle conversation'
  ),
  'New Maintenance Request': translation(
    'Nueva solicitud de mantenimiento',
    'Nouvelle demande de maintenance'
  ),
  'New Password': translation('Nueva contraseña', 'Nouveau mot de passe'),
  'Next scheduled date:': translation(
    'Próxima fecha programada:',
    'Prochaine date prévue :'
  ),
  'New Request': translation('Nueva solicitud', 'Nouvelle demande'),
  No: translation('No', 'Non'),
  'No outstanding invoices': translation(
    'No hay facturas pendientes',
    'Aucune facture impayée'
  ),
  'No Site': translation('Sin sitio', 'Aucun site'),
  'No Vendor': translation('Sin proveedor', 'Aucun fournisseur'),
  Ok: translation('Aceptar', 'OK'),
  Outstanding: translation('Pendiente', 'Impayé'),
  'Outstanding Invoices': translation(
    'Facturas pendientes',
    'Factures impayées'
  ),
  'Partially Applied': translation(
    'Parcialmente aplicado',
    'Partiellement imputé'
  ),
  'Partially Paid': translation('Parcialmente pagado', 'Partiellement payé'),
  'Password changed, logging out shortly...': translation(
    'Contraseña cambiada. Cerrando sesión en breve...',
    'Mot de passe modifié. Déconnexion imminente...'
  ),
  'Pay all outstanding charges': translation(
    'Pagar todos los cargos pendientes',
    'Payer tous les frais impayés'
  ),
  'Pay Now': translation('Pagar ahora', 'Payer maintenant'),
  'Pay scheduled amount': translation(
    'Pagar el monto programado',
    'Payer le montant prévu'
  ),
  Paid: translation('Pagado', 'Payé'),
  Payer: translation('Pagador', 'Payeur'),
  'Payment Amount:': translation('Monto del pago:', 'Montant du paiement :'),
  'Payment Date:': translation('Fecha de pago:', 'Date du paiement :'),
  'Payment Status:': translation('Estado del pago:', 'Statut du paiement :'),
  'Payment successful': translation('Pago exitoso', 'Paiement réussi'),
  'Payment successful ': translation('Pago exitoso ', 'Paiement réussi '),
  'Payment successful, but there was an error setting up autopay. Please contact your property manager for assistance.':
    translation(
      'El pago se realizó correctamente, pero hubo un error al configurar el pago automático. Comuníquese con el administrador de la propiedad para obtener ayuda.',
      "Le paiement a réussi, mais une erreur s'est produite lors de la configuration du paiement automatique. Veuillez communiquer avec votre gestionnaire immobilier pour obtenir de l'aide."
    ),
  Payments: translation('Pagos', 'Paiements'),
  'Payments are securely processed.': translation(
    'Los pagos se procesan de forma segura.',
    'Les paiements sont traités en toute sécurité.'
  ),
  'Payments Received': translation('Pagos recibidos', 'Paiements reçus'),
  'Payments will be charged on your': translation(
    'Los pagos se cargarán a su',
    'Les paiements seront débités de votre'
  ),
  'Please fix the following errors:': translation(
    'Corrija los siguientes errores:',
    'Veuillez corriger les erreurs suivantes :'
  ),
  Personalize: translation('Personalizar', 'Personnaliser'),
  'Personalize your Tenant Assistant': translation(
    'Personalice su asistente para inquilinos',
    'Personnalisez votre assistant locataire'
  ),
  'Preparing an answer': translation(
    'Preparando una respuesta',
    "Préparation d'une réponse"
  ),
  'Processing payment': translation(
    'Procesando el pago',
    'Traitement du paiement'
  ),
  'Property management follow-up': translation(
    'Seguimiento de la administración de la propiedad',
    'Suivi par la gestion immobilière'
  ),
  'Property manager': translation(
    'Administrador de la propiedad',
    'Gestionnaire immobilier'
  ),
  Qty: translation('Cant.', 'Qté'),
  'Reply in this thread...': translation(
    'Responder en esta conversación...',
    'Répondre dans cette conversation...'
  ),
  'Reply to property management': translation(
    'Responder a la administración de la propiedad',
    'Répondre à la gestion immobilière'
  ),
  'Replies in this thread go directly to property management.': translation(
    'Las respuestas de esta conversación se envían directamente a la administración de la propiedad.',
    'Les réponses dans cette conversation sont envoyées directement à la gestion immobilière.'
  ),
  Request: translation('Solicitud', 'Demande'),
  'Request Date': translation('Fecha de la solicitud', 'Date de la demande'),
  'Request sent': translation('Solicitud enviada', 'Demande envoyée'),
  'Request#': translation('Solicitud n.º', 'N° de demande'),
  'Review & Pay': translation('Revisar y pagar', 'Vérifier et payer'),
  'Reviewing your request': translation(
    'Revisando su solicitud',
    'Vérification de votre demande'
  ),
  'Routing number': translation('Número de ruta', "Numéro d'acheminement"),
  'Routing number confirmation': translation(
    'Confirmación del número de ruta',
    "Confirmation du numéro d'acheminement"
  ),
  Save: translation('Guardar', 'Enregistrer'),
  'Select Attachments to Upload': translation(
    'Seleccionar archivos adjuntos para cargar',
    'Sélectionner les pièces jointes à téléverser'
  ),
  'Save Card': translation('Guardar', 'Enregistrer'),
  'Saving assistant identity': translation(
    'Guardando la identidad del asistente',
    "Enregistrement de l'identité de l'assistant"
  ),
  'Saving file': translation('Guardando archivo', 'Enregistrement du fichier'),
  Savings: translation('Ahorros', "Compte d'épargne"),
  'Schedule Payment': translation('Programar pago', 'Planifier le paiement'),
  Scheduled: translation('Programado', 'Planifié'),
  'Scheduled Amount': translation('Monto programado', 'Montant planifié'),
  'Scheduled payments': translation('Pagos programados', 'Paiements planifiés'),
  'Scheduled Payments': translation('Pagos programados', 'Paiements planifiés'),
  'Scheduling payment': translation(
    'Programando el pago',
    'Planification du paiement'
  ),
  Searching: translation('Buscando', 'Recherche en cours'),
  Send: translation('Enviar', 'Envoyer'),
  'Send a message': translation('Enviar un mensaje', 'Envoyer un message'),
  'Sending message': translation('Enviando el mensaje', 'Envoi du message'),
  'Shared with Me': translation('Compartido conmigo', 'Partagés avec moi'),
  'Sign Out': translation('Cerrar sesión', 'Se déconnecter'),
  'Signed Documents': translation('Documentos firmados', 'Documents signés'),
  'Signing out': translation('Cerrando sesión', 'Déconnexion'),
  Site: translation('Sitio', 'Site'),
  'Something went wrong': translation(
    'Algo salió mal',
    "Une erreur s'est produite"
  ),
  'Something went wrong.': translation(
    'Algo salió mal.',
    "Une erreur s'est produite."
  ),
  Spanish: translation('Español', 'Espagnol'),
  Subject: translation('Asunto', 'Objet'),
  Submit: translation('Enviar', 'Soumettre'),
  'Submit question': translation('Enviar pregunta', 'Soumettre la question'),
  'Submit Request': translation('Enviar solicitud', 'Soumettre la demande'),
  Support: translation('Soporte', 'Assistance'),
  'Support office': translation('Oficina de soporte', "Bureau d'assistance"),
  'Support office map': translation(
    'Mapa de la oficina de soporte',
    "Carte du bureau d'assistance"
  ),
  Tel: translation('Tel.', 'Tél.'),
  TB: translation('TB', 'To'),
  Tenant: translation('Inquilino', 'Locataire'),
  'The tenant assistant is temporarily unavailable. Please wait a moment and try again.':
    translation(
      'El asistente para inquilinos no está disponible temporalmente. Espere un momento e inténtelo de nuevo.',
      "L'assistant locataire est temporairement indisponible. Veuillez patienter un instant et réessayer."
    ),
  'The website is currently undergoing maintenance, please try again later.':
    translation(
      'El sitio web está en mantenimiento. Inténtelo de nuevo más tarde.',
      'Le site Web est actuellement en maintenance. Veuillez réessayer plus tard.'
    ),
  'There was an error adding attachments': translation(
    'Hubo un error al agregar los archivos adjuntos',
    "Une erreur s'est produite lors de l'ajout des pièces jointes"
  ),
  'There was an error adding attachments. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al agregar los archivos adjuntos. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de l'ajout des pièces jointes. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error creating the maintenance request': translation(
    'Hubo un error al crear la solicitud de mantenimiento',
    "Une erreur s'est produite lors de la création de la demande de maintenance"
  ),
  'There was an error creating the maintenance request. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al crear la solicitud de mantenimiento. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de la création de la demande de maintenance. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error creating the payment': translation(
    'Hubo un error al crear el pago',
    "Une erreur s'est produite lors de la création du paiement"
  ),
  'There was an error creating the payment method': translation(
    'Hubo un error al crear el método de pago',
    "Une erreur s'est produite lors de la création du mode de paiement"
  ),
  'There was an error creating the payment method. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al crear el método de pago. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de la création du mode de paiement. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error creating the payment. Please reload the page and try again.':
    translation(
      'Hubo un error al crear el pago. Vuelva a cargar la página e inténtelo de nuevo.',
      "Une erreur s'est produite lors de la création du paiement. Veuillez recharger la page et réessayer."
    ),
  'There was an error creating the scheduled payment': translation(
    'Hubo un error al crear el pago programado',
    "Une erreur s'est produite lors de la création du paiement planifié"
  ),
  'There was an error deleting the file': translation(
    'Hubo un error al eliminar el archivo',
    "Une erreur s'est produite lors de la suppression du fichier"
  ),
  'There was an error deleting the file. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al eliminar el archivo. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de la suppression du fichier. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error deleting the payment method': translation(
    'Hubo un error al eliminar el método de pago',
    "Une erreur s'est produite lors de la suppression du mode de paiement"
  ),
  'There was an error deleting the payment method. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al eliminar el método de pago. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de la suppression du mode de paiement. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error disabling autopay': translation(
    'Hubo un error al desactivar el pago automático',
    "Une erreur s'est produite lors de la désactivation du paiement automatique"
  ),
  'There was an error sending your question': translation(
    'Hubo un error al enviar su pregunta',
    "Une erreur s'est produite lors de l'envoi de votre question"
  ),
  'There was an error setting up autopay': translation(
    'Hubo un error al configurar el pago automático',
    "Une erreur s'est produite lors de la configuration du paiement automatique"
  ),
  'There was an error setting up autopay. Please contact your property manager for assistance.':
    translation(
      'Hubo un error al configurar el pago automático. Comuníquese con el administrador de la propiedad para obtener ayuda.',
      "Une erreur s'est produite lors de la configuration du paiement automatique. Veuillez communiquer avec votre gestionnaire immobilier pour obtenir de l'aide."
    ),
  'There was an error updating the email address. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al actualizar el correo electrónico. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de la mise à jour de l'adresse courriel. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error updating the language. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al actualizar el idioma. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de la mise à jour de la langue. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error updating the password. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al actualizar la contraseña. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de la mise à jour du mot de passe. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error updating the payment method': translation(
    'Hubo un error al actualizar el método de pago',
    "Une erreur s'est produite lors de la mise à jour du mode de paiement"
  ),
  'There was an error updating the payment method. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al actualizar el método de pago. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors de la mise à jour du mode de paiement. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  'There was an error uploading the file': translation(
    'Hubo un error al cargar el archivo',
    "Une erreur s'est produite lors du téléversement du fichier"
  ),
  'There was an error uploading the file. Please contact Property Matrix support for assistance.':
    translation(
      'Hubo un error al cargar el archivo. Comuníquese con el soporte de Property Matrix para obtener ayuda.',
      "Une erreur s'est produite lors du téléversement du fichier. Veuillez communiquer avec l'assistance de Property Matrix pour obtenir de l'aide."
    ),
  Thinking: translation('Pensando', 'Réflexion en cours'),
  Threads: translation('Conversaciones', 'Conversations'),
  Total: translation('Total', 'Total'),
  'Total Amount': translation('Monto total', 'Montant total'),
  'Total Applied': translation('Total aplicado', 'Total imputé'),
  'Total Owing': translation('Total adeudado', 'Total à payer'),
  'Total Paid': translation('Total pagado', 'Total payé'),
  'Total Received': translation('Total recibido', 'Total reçu'),
  'Unable to save assistant identity': translation(
    'No se pudo guardar la identidad del asistente',
    "Impossible d'enregistrer l'identité de l'assistant"
  ),
  'Unable to use the default assistant identity': translation(
    'No se pudo usar la identidad predeterminada del asistente',
    "Impossible d'utiliser l'identité par défaut de l'assistant"
  ),
  Unapplied: translation('Sin aplicar', 'Non imputé'),
  Unpaid: translation('Sin pagar', 'Non payé'),
  'Unknown assistant thread or current tenant': translation(
    'Conversación del asistente o inquilino actual desconocidos',
    "Conversation de l'assistant ou locataire actuel inconnu"
  ),
  'Unknown current tenant': translation(
    'Inquilino actual desconocido',
    'Locataire actuel inconnu'
  ),
  'Unknown current tenant identity': translation(
    'Identidad del inquilino actual desconocida',
    'Identité du locataire actuel inconnue'
  ),
  'Upcoming invoices': translation('Próximas facturas', 'Factures à venir'),
  'Updating language': translation(
    'Actualizando el idioma',
    'Mise à jour de la langue'
  ),
  'Updating payment method': translation(
    'Actualizando el método de pago',
    'Mise à jour du mode de paiement'
  ),
  Upload: translation('Cargar', 'Téléverser'),
  'Upload attachments': translation(
    'Cargar archivos adjuntos',
    'Téléverser des pièces jointes'
  ),
  'Upload failed': translation('Error al cargar', 'Échec du téléversement'),
  Uploaded: translation('Cargado', 'Téléversé'),
  uploaded: translation('cargado', 'téléversé'),
  'Uploading documents': translation(
    'Cargando documentos',
    'Téléversement des documents'
  ),
  'Use ACH withdraw': translation(
    'Usar retiro ACH',
    'Utiliser le prélèvement ACH'
  ),
  'Using default assistant identity': translation(
    'Usando la identidad predeterminada del asistente',
    "Utilisation de l'identité par défaut de l'assistant"
  ),
  Vendor: translation('Proveedor', 'Fournisseur'),
  View: translation('Ver', 'Afficher'),
  'View Invoice': translation('Ver factura', 'Afficher la facture'),
  'View Invoice Payment': translation(
    'Ver pago de factura',
    'Afficher le paiement de facture'
  ),
  'WARNING: Large AutoPay': translation(
    'ADVERTENCIA: pago automático grande',
    'AVERTISSEMENT : paiement automatique élevé'
  ),
  'We could not confirm that your question finished processing. Please check or refresh the conversation before sending it again.':
    translation(
      'No pudimos confirmar que su pregunta haya terminado de procesarse. Revise o actualice la conversación antes de volver a enviarla.',
      "Nous n'avons pas pu confirmer que le traitement de votre question était terminé. Veuillez consulter ou actualiser la conversation avant de l'envoyer à nouveau."
    ),
  'When charges become available': translation(
    'Cuando haya cargos disponibles',
    'Lorsque des frais sont disponibles'
  ),
  Yes: translation('Sí', 'Oui'),
  'Yes, Disable AutoPay': translation(
    'Sí, desactivar el pago automático',
    'Oui, désactiver le paiement automatique'
  ),
  "You can't pay more than the outstanding amount for an invoice.": translation(
    'No puede pagar más del monto pendiente de una factura.',
    "Vous ne pouvez pas payer plus que le montant impayé d'une facture."
  ),
  'You do not have permission to view this page': translation(
    'No tiene permiso para ver esta página',
    "Vous n'êtes pas autorisé à afficher cette page"
  ),
  "You must enter an amount for all invoices. Uncheck any invoices you don't want to pay on the previous page.":
    translation(
      'Debe ingresar un monto para todas las facturas. Desmarque en la página anterior las facturas que no desea pagar.',
      'Vous devez saisir un montant pour toutes les factures. Décochez les factures que vous ne souhaitez pas payer sur la page précédente.'
    ),
  'Your email has been changed successfully. You will need to log in again. Please check your email for more details.':
    translation(
      'Su correo electrónico se cambió correctamente. Deberá iniciar sesión de nuevo. Revise su correo electrónico para más detalles.',
      'Votre adresse courriel a été modifiée. Vous devrez vous reconnecter. Consultez votre courriel pour obtenir plus de détails.'
    ),
  'Your name': translation('Su nombre', 'Votre nom'),
  'Your phone number': translation(
    'Su número de teléfono',
    'Votre numéro de téléphone'
  ),
  'Your reply was sent, but the conversation could not be refreshed. Please reload the page.':
    translation(
      'Su respuesta se envió, pero no se pudo actualizar la conversación. Vuelva a cargar la página.',
      "Votre réponse a été envoyée, mais la conversation n'a pas pu être actualisée. Veuillez recharger la page."
    ),
  'Zip Code': translation('Código postal', 'Code postal'),
  of: translation('de', 'sur'),
  'Add a payment method': translation(
    'Agregar un método de pago',
    'Ajouter un mode de paiement'
  ),
  'Additional Settings': translation(
    'Configuración adicional',
    'Paramètres supplémentaires'
  ),
  'Amount still owing:': translation(
    'Monto aún adeudado:',
    'Montant restant à payer :'
  ),
  'Amount to be charged today:': translation(
    'Monto a cobrar hoy:',
    "Montant qui sera débité aujourd'hui :"
  ),
  'Are you sure you want to delete this file?': translation(
    '¿Seguro que desea eliminar este archivo?',
    'Voulez-vous vraiment supprimer ce fichier ?'
  ),
  'Are you sure you want to delete the payment method ending in': translation(
    '¿Seguro que desea eliminar el método de pago que termina en',
    'Voulez-vous vraiment supprimer le mode de paiement se terminant par'
  ),
  Back: translation('Atrás', 'Retour'),
  Description: translation('Descripción', 'Description'),
  Method: translation('Método', 'Mode'),
  'New Chat': translation('Chat nuevo', 'Nouveau clavardage'),
  'No recent threads yet': translation(
    'Aún no hay conversaciones recientes',
    'Aucune conversation récente'
  ),
  'Payment Method': translation('Método de pago', 'Mode de paiement'),
  'Personalize your assistant': translation(
    'Personalice su asistente',
    'Personnalisez votre assistant'
  ),
  'Portal Fee': translation('Tarifa del portal', 'Frais du portail'),
  'Security code': translation('Código de seguridad', 'Code de sécurité'),
  'Set by ': translation('Configurado por ', 'Défini par '),
  'Start a new conversation to ask about rent, lease details, maintenance, documents, or contacting your property manager.':
    translation(
      'Inicie una conversación nueva para preguntar sobre el alquiler, los detalles del contrato, el mantenimiento, los documentos o cómo contactar al administrador de la propiedad.',
      'Démarrez une nouvelle conversation pour poser des questions sur le loyer, les détails du bail, la maintenance, les documents ou la façon de communiquer avec votre gestionnaire immobilier.'
    ),
  'This only changes how the assistant appears to you. It does not affect its answers or other tenants.':
    translation(
      'Esto solo cambia cómo ve el asistente. No afecta sus respuestas ni a otros inquilinos.',
      "Cela modifie uniquement la façon dont l'assistant vous apparaît. Cela n'a aucune incidence sur ses réponses ni sur les autres locataires."
    ),
  'There are errors in the billing information. Please edit the address below.':
    translation(
      'Hay errores en la información de facturación. Edite la dirección a continuación.',
      "Les renseignements de facturation contiennent des erreurs. Modifiez l'adresse ci-dessous."
    ),
  'Total owing:': translation('Total adeudado:', 'Total à payer :'),
  'Total payment amount:': translation(
    'Monto total del pago:',
    'Montant total du paiement :'
  ),
  'Total:': translation('Total:', 'Total :'),
  'Unable to load image.': translation(
    'No se pudo cargar la imagen.',
    "Impossible de charger l'image."
  ),
  Uploading: translation('Cargando', 'Téléversement'),
  'Up to 24 characters. You can change this or reset at any time.': translation(
    'Hasta 24 caracteres. Puede cambiarlo o restablecerlo en cualquier momento.',
    "Jusqu'à 24 caractères. Vous pouvez le modifier ou rétablir la valeur par défaut à tout moment."
  ),
  'Use Bank Account': translation(
    'Usar cuenta bancaria',
    'Utiliser compte bancaire'
  ),
  'Use Credit Card': translation(
    'Usar tarjeta de crédito',
    'Utiliser carte de crédit'
  ),
  'Use default': translation(
    'Usar predeterminado',
    'Utiliser la valeur par défaut'
  ),
  'You are about to schedule an amount more than twice your next upcoming invoice.':
    translation(
      'Está a punto de programar un monto de más del doble de su próxima factura.',
      'Vous êtes sur le point de planifier un montant supérieur à deux fois celui de votre prochaine facture.'
    ),
  'You can only edit the expiration date, security code, and billing address of your card.':
    translation(
      'Solo puede editar la fecha de vencimiento, el código de seguridad y la dirección de facturación de su tarjeta.',
      "Vous pouvez uniquement modifier la date d'expiration, le code de sécurité et l'adresse de facturation de votre carte."
    ),
  'Appliance Repair': translation(
    'Reparación de electrodomésticos',
    "Réparation d'appareils électroménagers"
  ),
  Assigned: translation('Asignado', 'Assigné'),
  "can't be blank": translation(
    'no puede estar en blanco',
    'ne peut pas être vide'
  ),
  'is invalid': translation('no es válida', "n'est pas valide"),
  'Clean Up': translation('Limpieza', 'Nettoyage'),
  Electrical: translation('Electricidad', 'Électricité'),
  'Final Cleaning': translation('Limpieza final', 'Nettoyage final'),
  'General Maintenance': translation(
    'Mantenimiento general',
    'Maintenance générale'
  ),
  'General Repair': translation('Reparación general', 'Réparation générale'),
  HVAC: translation('Climatización', 'CVCA'),
  Inspection: translation('Inspección', 'Inspection'),
  'Make Ready': translation(
    'Preparación para ocupación',
    'Préparation du logement'
  ),
  'Move Out': translation('Desocupación', 'Départ'),
  Other: translation('Otro', 'Autre'),
  Plumbing: translation('Plomería', 'Plomberie'),
  'Prop/Demolition': translation(
    'Propiedad/Demolición',
    'Propriété/Démolition'
  ),
  '(optional)': translation('(opcional)', '(facultatif)'),
  'Add Attachment': translation(
    'Agregar archivo adjunto',
    'Ajouter une pièce jointe'
  ),
  'Add photos or files': translation(
    'Agregar fotos o archivos',
    'Ajouter des photos ou des fichiers'
  ),
  'A few safe checks may help': translation(
    'Algunas comprobaciones seguras pueden ayudar',
    'Quelques vérifications sans danger pourraient aider'
  ),
  'Complete the required fields to submit the request.': translation(
    'Complete los campos obligatorios para enviar la solicitud.',
    'Remplissez les champs obligatoires pour soumettre la demande.'
  ),
  'Describe what’s happening': translation(
    'Describa lo que está sucediendo',
    'Décrivez ce qui se passe'
  ),
  'Details help us suggest the right next step': translation(
    'Los detalles nos ayudan a sugerir el siguiente paso adecuado',
    'Les détails nous aident à suggérer la prochaine étape appropriée'
  ),
  'Didn’t fix it': translation(
    'No lo solucionó',
    'Cela n’a pas résolu le problème'
  ),
  'Generating maintenance suggestions': translation(
    'Generando sugerencias de mantenimiento',
    'Génération de suggestions de maintenance'
  ),
  'It’s fixed': translation('Está solucionado', 'C’est résolu'),
  'Keep it short and specific': translation(
    'Sea breve y específico',
    'Soyez bref et précis'
  ),
  'New maintenance request': translation(
    'Nueva solicitud de mantenimiento',
    'Nouvelle demande de maintenance'
  ),
  Next: translation('Siguiente', 'Suivant'),
  'Nice, that fixed it!': translation(
    '¡Bien, se solucionó!',
    'Parfait, c’est résolu !'
  ),
  'Open Requests': translation('Solicitudes abiertas', 'Demandes ouvertes'),
  'Our AI assistant helped solve the issue and we’ve marked this request as solved.':
    translation(
      'Nuestro asistente de IA ayudó a resolver el problema y hemos marcado esta solicitud como resuelta.',
      'Notre assistant IA a aidé à résoudre le problème et nous avons marqué cette demande comme résolue.'
    ),
  'Photos or files': translation('Fotos o archivos', 'Photos ou fichiers'),
  'Report an issue and keep track of your requests.': translation(
    'Informe de un problema y haga seguimiento de sus solicitudes.',
    'Signalez un problème et suivez vos demandes.'
  ),
  'Request Details': translation(
    'Detalles de la solicitud',
    'Détails de la demande'
  ),
  'Select a Category': translation(
    'Seleccione una categoría',
    'Sélectionnez une catégorie'
  ),
  'Sending request': translation('Enviando solicitud', 'Envoi de la demande'),
  'Solved by AI': translation('Resuelto por IA', 'Résolu par l’IA'),
  Status: translation('Estado', 'Statut'),
  'Suggestions are optional.': translation(
    'Las sugerencias son opcionales.',
    'Les suggestions sont facultatives.'
  ),
  'Suggestions to try': translation(
    'Sugerencias para probar',
    'Suggestions à essayer'
  ),
  'Thinking...': translation('Pensando...', 'Réflexion en cours...'),
  Type: translation('Tipo', 'Type'),
  'View Request': translation('Ver solicitud', 'Voir la demande'),
  'We couldn’t generate suggestions right now. You can still submit this request.':
    translation(
      'No pudimos generar sugerencias en este momento. Aun así, puede enviar esta solicitud.',
      'Nous n’avons pas pu générer de suggestions pour le moment. Vous pouvez tout de même soumettre cette demande.'
    ),
  'Your property manager has received the maintenance request. You can follow updates from the Maintenance page.':
    translation(
      'El administrador de la propiedad ha recibido la solicitud de mantenimiento. Puede seguir las actualizaciones desde la página de Mantenimiento.',
      'Votre gestionnaire immobilier a reçu la demande de maintenance. Vous pouvez suivre les mises à jour depuis la page Maintenance.'
    ),
};

export const translate = (sourceText: string, language: string) => {
  if (language !== 'es' && language !== 'fr') return sourceText;

  const blockedCardMessage = sourceText.match(
    /^This card is temporarily unavailable\. You may try again after (.+) or use another payment method\.$/
  );
  if (blockedCardMessage)
    return translationEntries[
      'This card is temporarily unavailable. You may try again after {time} or use another payment method.'
    ][language].replace('{time}', blockedCardMessage[1]);

  const codedMessage = sourceText.match(
    /^(We couldn’t (?:complete your request\.|confirm whether your payment was completed\.) .* Error code:) ([A-Z]+-[1-9][0-9]*\.)$/
  );
  if (codedMessage && translationEntries[codedMessage[1]])
    return `${translationEntries[codedMessage[1]][language]} ${codedMessage[2]}`;

  return translationEntries[sourceText]?.[language] || sourceText;
};

export const useTranslate = () => {
  const { currentLanguage } = useGlobalContext();

  return useCallback(
    (sourceText: string) => translate(sourceText, currentLanguage ?? 'en'),
    [currentLanguage]
  );
};

export const translateErrorTypes = <
  T extends { messages: ReadonlyArray<string> },
>(
  errors: ReadonlyArray<T>,
  translateText: (sourceText: string) => string
): T[] =>
  errors.map((error) => ({
    ...error,
    messages: error.messages.map((message) => translateText(message)),
  }));
